export default __webpack_public_path__ + "static/media/logos.5919e0a1.svg";